import { fetchAuthSession } from 'aws-amplify/auth';

const apiUrl = process.env.REACT_APP_CONTENT_API_URL;

const nonAuthRequest = async (path: string, customConfig?: {}, isRaw: boolean = false) => {
  const config = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    ...customConfig,
  };

  const res = await fetch(`${apiUrl}/${path}`, config);
  const data = isRaw ? res : await res.json();

  if (!res.ok) {
    throw new Error(data.message);
  }

  return data;
};

const authRequest = async (path: string, customConfig?: {}, isRaw: boolean = false) => {
  const session = await fetchAuthSession();
  const jwtToken = session.tokens?.idToken?.toString();

  if (!jwtToken) {
    throw new Error('No ID token found in session');
  }

  const config = {
    method: 'GET',
    headers: {
      Authorization: jwtToken,
      'Content-Type': 'application/json',
    },
    ...customConfig,
  };

  const res = await fetch(`${apiUrl}/${path}`, config);
  const data = isRaw ? res : await res.json();

  if (!res.ok) {
    throw new Error(data.message);
  }

  return data;
};

const authSendEmail = async (path: string, customConfig?: {}) => {
  const session = await fetchAuthSession();
  const jwtToken = session.tokens?.idToken?.toString();

  if (!jwtToken) {
    throw new Error('No ID token found in session');
  }

  const config = {
    method: 'POST',
    headers: {
      Authorization: jwtToken,
      'Content-Type': 'application/json',
    },
    ...customConfig,
  };

  const res = await fetch(`${apiUrl}/${path}`, config);

  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.message);
  }
};

export default {
  authRequest,
  authSendEmail,
  nonAuthRequest,
};
